module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_3.be3830a3.png";